/** Valores por defecto (fallback si la API no responde) */
export const DEFAULT_BRANDING = {
  logo_full: "/assets/logo-ksm-certificate.png",
  logo_icon: "/assets/logo-ksm-certificate.png",
  logo_dark: "",
  favicon: "/assets/favicon.svg",
  hero_home: "/assets/hero-oilfield.svg",
  hero_login: "/assets/hero-industrial.svg",
  hero_validate: "/assets/hero-oilfield.svg",
  course_default: "/assets/course-default.svg",
  og_image: "/assets/hero-oilfield.svg",
  certificate_logo: "",
  certificate_stamp: "",
  certificate_stamp_size: "96",
  landing_about: "",
  landing_impact: "",
  landing_careers: "",
  landing_contact: "",
  site_name: "KSM Services",
  site_tagline: "Capacitación Industrial Oil & Gas",
  hero_title: "Formamos al talento",
  hero_title_accent: "que mueve la industria",
  hero_description:
    "Programas de formación certificados en seguridad industrial, salud ocupacional y medio ambiente. Respaldados por 15 años de experiencia en el sector Oil & Gas mexicano.",
  meta_title: "KSM Services - Capacitación Industrial Oil & Gas | KASUMAR",
  meta_description:
    "KSM Services by KASUMAR ofrece capacitación certificada en seguridad industrial, salud ocupacional y medio ambiente para el sector Oil & Gas en México.",
  meta_keywords: "capacitación industrial, seguridad Oil Gas, cursos H2S, KASUMAR, KSM Services",
  contact_email: "cursos@kasumar.com",
  contact_phone: "+52 (993) 123 4567",
  contact_address: "Villahermosa, Tabasco, México",
  contact_secondary_email: "ksm.services@gmail.com",
  social_facebook: "",
  social_instagram: "",
  social_linkedin: "",
  site_url: typeof window !== "undefined" ? window.location.origin : "",
  updated_at: "",
};

/** @deprecated usar useBranding() */
export const LOGO_FULL = DEFAULT_BRANDING.logo_full;
export const LOGO_ICON = DEFAULT_BRANDING.logo_icon;
export const ASSETS = {
  heroHome: DEFAULT_BRANDING.hero_home,
  heroLogin: DEFAULT_BRANDING.hero_login,
  heroValidate: DEFAULT_BRANDING.hero_validate,
  courseDefault: DEFAULT_BRANDING.course_default,
} as const;
